import { PromotionalOffersList } from '@/components/promotional-offers/PromotionalOffersList';
import { PageContainer } from '@startupquickstart/frontend';

/**
 * Promotional Offers list page
 * Non-internal organizations only see their own promotional offers
 */
export function PromotionalOffersPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Promotional Offers', current: true },
  ];

  return (
    <PageContainer>
      <PromotionalOffersList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
